import { observer } from 'mobx-react-lite'
import { Avatar } from '@/components/Avatar'
import {
  type ColumnDensity,
  type TestIdProps,
} from '@/components/Table/TableCell'
import { formattedSecondaryInfo } from '@/features/jobs/list/jobs-table-columns'
import { type SearchableJob } from '@/features/jobs/list/SearchableJob'
import { type JobTicket } from '@/features/jobs/tickets/JobTicket'
import {
  PrimaryCell,
  type PrimaryCellProps,
} from '@/features/jobs/list/components/JobManagement/JobsTable/JobsTableRow'

export interface PrimaryCellContainerProps extends TestIdProps {
  job: SearchableJob
  openTicket: JobTicket | null
  density: ColumnDensity
}

export const PrimaryCellContainer = observer(function PrimaryCellContainer({
  job,
  openTicket,
  density,
  testId,
}: PrimaryCellContainerProps) {
  return (
    <PrimaryCell
      {...mapPrimaryCellProps(job, openTicket)}
      density={density}
      testId={testId}
    />
  )
})

/**
 * Maps a job to what its primary cell shows.
 */
export function mapPrimaryCellProps(
  job: SearchableJob,
  openTicket: JobTicket | null,
): Omit<PrimaryCellProps, 'density' | 'testId'> {
  const subjects =
    job.currentUserMember?.type === 'Client' && job.proMembers.length
      ? job.proMembers
      : job.clientMembers

  return {
    avatar: <Avatar size={24} subject={subjects} />,
    displayName: job.displayName,
    secondaryInfo: formattedSecondaryInfo(job),
    unreadCount: job.conversation?.unreadCount ?? 0,
    openTicket: openTicket
      ? {
          statusMessage: openTicket.statusMessage,
          lastUpdated: openTicket.lastUpdated,
        }
      : null,
  }
}
